<div class="portal-list-page">
  <div class="page-header">
    <h2 class="page-title">Makine Markaları</h2>
    <lib-button variant="primary" (buttonClick)="openAdd()">
      <span class="btn-content">
        <svg lucidePlus [size]="16" [strokeWidth]="2.25" aria-hidden="true"></svg>
        Ekle
      </span>
    </lib-button>
  </div>

  <div class="search-bar">
    <input
      class="search-input"
      type="text"
      placeholder="Ada göre ara..."
      [(ngModel)]="searchTerm"
      (keyup.enter)="onSearch()"
    />
    <lib-button variant="outline" size="sm" (buttonClick)="onSearch()">
      <span class="btn-content">
        <svg lucideSearch [size]="15" [strokeWidth]="2" aria-hidden="true"></svg>
        Ara
      </span>
    </lib-button>
    @if (searchTerm) {
      <lib-button variant="text" size="sm" (buttonClick)="clearSearch()">Temizle</lib-button>
    }
  </div>

  @if (loading()) {
    <div class="loading-overlay">
      <div class="spinner"></div>
      <p>Yükleniyor...</p>
    </div>
  } @else {
    <div class="table-wrapper">
      <table class="data-table">
        <thead>
          <tr>
            <th class="action-col">
              <div class="row-actions">
                <lib-button variant="text" size="sm" class="portal-icon-btn" (buttonClick)="load()" title="Yenile">
                  <svg lucideRefreshCw [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
                </lib-button>
              </div>
            </th>
            <th>Ad</th>
            <th>Aktif</th>
          </tr>
        </thead>
        <tbody>
          @if (items().length === 0) {
            <tr><td colspan="3" class="empty-row">Kayıt bulunamadı</td></tr>
          }
          @for (item of items(); track item.id) {
            <tr>
              <td class="action-col">
                <div class="row-actions">
                  <lib-button variant="text" size="sm" class="portal-icon-btn" (buttonClick)="openEdit(item)" title="Düzenle">
                    <svg lucidePencil [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
                  </lib-button>
                  <lib-button
                    variant="text"
                    size="sm"
                    class="portal-icon-btn portal-icon-btn--danger"
                    (buttonClick)="delete(item)"
                    title="Sil"
                  >
                    <svg lucideTrash2 [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
                  </lib-button>
                </div>
              </td>
              <td>{{ item.name }}</td>
              <td>
                <span class="badge" [class.badge-yes]="item.isActive" [class.badge-no]="!item.isActive">
                  {{ item.isActive ? 'Aktif' : 'Pasif' }}
                </span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <lib-button variant="text" size="sm" class="portal-icon-btn" [disabled]="page() === 0" (buttonClick)="prevPage()" title="Önceki">
        <svg lucideChevronLeft [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
      </lib-button>
      <span class="page-info">Sayfa {{ page() + 1 }} / {{ totalPages() || 1 }}</span>
      <lib-button variant="text" size="sm" class="portal-icon-btn" [disabled]="page() >= totalPages() - 1" (buttonClick)="nextPage()" title="Sonraki">
        <svg lucideChevronRight [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
      </lib-button>
    </div>
  }
</div>

@if (showFormDialog()) {
  <div class="dialog-backdrop" (click)="closeFormDialog()"></div>
  <div class="dialog">
    <div class="dialog-header">
      <h3>{{ isEdit() ? 'Markayı Düzenle' : 'Yeni Marka' }}</h3>
      <button type="button" class="dialog-close" (click)="closeFormDialog()" aria-label="Kapat">
        <svg lucideX [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
      </button>
    </div>
    <div class="dialog-body">
      <div class="form-field">
        <label class="field-label">Ad *</label>
        <input
          class="form-input"
          type="text"
          [ngModel]="formModel().name"
          (ngModelChange)="updateField('name', $event)"
          placeholder="Marka adı"
        />
      </div>
      <div class="form-field checkbox-field">
        <input
          type="checkbox"
          id="brandIsActive"
          [ngModel]="formModel().isActive"
          (ngModelChange)="updateField('isActive', $event)"
        />
        <label for="brandIsActive">Aktif</label>
      </div>
    </div>
    <div class="dialog-footer">
      <lib-button variant="outline" (buttonClick)="closeFormDialog()">İptal</lib-button>
      <lib-button variant="primary" [disabled]="formSaving()" (buttonClick)="save()">
        {{ formSaving() ? 'Kaydediliyor...' : 'Kaydet' }}
      </lib-button>
    </div>
  </div>
}
